import { render, staticRenderFns } from "./question-category.vue?vue&type=template&id=9e410f9a&scoped=true&"
import script from "./question-category.vue?vue&type=script&lang=js&"
export * from "./question-category.vue?vue&type=script&lang=js&"
import style0 from "./question-category.vue?vue&type=style&index=0&id=9e410f9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e410f9a",
  null
  
)

export default component.exports